<!-- eslint-disable max-len -->
<template>
  <div class="d-flex flex-column">
    <!-- Screen Mode & Save -->
    <div
      :class="{ 'screen-mode-and-save-scroll': isScroll }"
      class="screen-mode-and-save justify-content-end"
    >
      <div class="wrap-screen-mode justify-content-end">
        <button
          class="save-button"
          @click="submitForm"
        >
          Save
        </button>
      </div>
    </div>

    <div class="card-page">
      <!-- Button Code Editor per View -->
      <div class="icon-code-editor">
        <img
          src="@/assets/new-form-ui/code-editor.svg"
          @click="openModalCodeEditor"
        >
        <div class="tooltip-component">
          Code Editor
        </div>
      </div>
      <!-- Button Properties setup view -->
      <div
        :class="{'error-input' : $v.dataSetup.column.title.$error || $v.dataSetup.column.description.$error || $v.dataSetup.column.color.$error || $v.dataSetup.column.start_date_time.$error || $v.dataSetup.column.end_date_time.$error}"
        class="icon-setup-view"
        @click="openConfiguration"
      >
        <img
          src="@/assets/new-form-ui/setup.svg"
        >
        <div class="tooltip-component">
          Configuration
        </div>
      </div>

      <!-- Title -->
      <div class="card-page-title card-page-title-white">
        <b-form>
          <input
            v-model="dataSetup.title"
            :class="{'error-input' : $v.dataSetup.title.$error}"
            type="text"
            class="input-title"
            placeholder="Enter title here"
          >
        </b-form>
      </div>

      <!-- Content -->
      <div class="card-page-content pt-3">
        <!-- Button -->
        <div class="d-flex align-items-center mb-2">
          <b-button
            class="btn grey btn-import-form m__r--5"
            disabled
          >
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
          <b-button
            class="btn grey btn-import-form m__r--5"
            disabled
          >
            <i class="fa fa-cloud-upload fa-lg"/> Import
          </b-button>
          <b-button
            class="btn grey btn-import-form m__r--5"
            disabled
          >
            <i class="fa fa-download fa-lg"/> Export
          </b-button>
          <b-button
            id="filterPopover"
            class="btn grey btn-import-form m__r--5"
            @click="showPopover = true"
          >
            <i class="fa fa-filter fa-lg"/> Filter
          </b-button>
        </div>

        <!-- Calendar -->
        <j-skeleton-calendar v-if="isLoading" />
        <j-calender-view-widget
          v-else
          :form-data="formData"
          :form-ui="formUi"
          :use-title="false"
        />
      </div>
    </div>

    <!-- Delete View -->
    <div class="card-transparent m__t--15">
      <span
        v-if="formDetail.calendar_view"
        class="cursor-pointer"
        style="font-size: 14px"
        @click="deleteView"
      >
        <i class="fa fa-trash"/> <small>Delete this view</small>
      </span>
    </div>

    <!-- Popover Filter -->
    <b-popover
      :show.sync="showPopover"
      target="filterPopover"
      container="newExperienceManager"
      triggers="click blur"
      placement="bottom"
    >
      <popup-filter
        :filters="dataSetup.search_options_list"
      />
    </b-popover>

    <!-- Configuration -->
    <calendar-configuration
      v-if="isOpenConfiguration"
      :id="idConfiguration"
      :data-config="dataSetup"
      :list-function="listFunction"
      :variables="optionVariables"
      @close-configuration="toggleConfiguration(false)"
      @submit="submitConfig"
    />

    <!-- Modal Field Library -->
    <modal-field-library
      v-if="showModalFieldLibrary"
      @close-modal="closeModalFieldLibrary"
    />

    <!-- Modal External Api -->
    <b-modal
      ref="modalExternalApi"
      :hide-header="true"
      :hide-footer="true"
      class="modal-external-api"
      no-close-on-backdrop
      no-close-on-esc
    >
      <modal-external-api-field
        v-if="showModalExternalUrl"
      />
    </b-modal>

    <!-- Modal Code Editor -->
    <b-modal
      ref="modalCodeEditor"
      :hide-header="true"
      :hide-footer="true"
      class="modal-code-editor-wrap"
      no-close-on-backdrop
      no-close-on-esc
    >
      <modal-code-editor
        v-if="showModalCodeEditor"
        :view-data="viewJsonData"
        view-title="Calendar View"
        type="calendar_view"
        @close="closeModalCodeEditor"
        @update="updateViewByCode"
      />
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable max-len, no-unused-vars, no-nested-ternary, camelcase, no-console */
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState, mapMutations } from 'vuex';
import jwtDecode from 'jwt-decode';
// Mixins
import jMixScroll from '@/mixins/form-ui-v2/jMixScroll';
import jMixToolbox from '@/mixins/form-ui-v2/jMixToolbox';
import jMixCodeEditorPerView from '@/mixins/form-ui-v2/jMixCodeEditorPerView';
// Components
import PopupFilter from '@/views/experience-manager-v2/popup/PopupFilter';
import jSkeletonCalendar from '@/views/experience-manager-v2/loading/jSkeletonCalendar';
import jCalenderViewWidget from '@/views/widget/widget-card/jCalenderViewWidget';
import CalendarConfiguration from '@/views/experience-manager-v2/partials/configuration/CalendarConfiguration';
import ModalFieldLibrary from '@/views/experience-manager-v2/popup/ModalFieldLibrary';
import ModalExternalApiField from '@/views/experience-manager-v2/popup/ModalExternalApiField';
import ModalCodeEditor from '@/views/experience-manager-v2/popup/ModalCodeEditor';

export default {
  components: {
    PopupFilter,
    jSkeletonCalendar,
    jCalenderViewWidget,
    CalendarConfiguration,
    ModalFieldLibrary,
    ModalExternalApiField,
    ModalCodeEditor,
  },

  mixins: [jMixScroll, jMixToolbox, jMixCodeEditorPerView],

  props: {
    formDetail: {
      type: Object,
      default: () => {},
    },
    isMultipleForm: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoading: true,
      dataSetup: {
        title: null,
        server_side_pagination: false,
        column: {
          title: null,
          description: null,
          color: null,
          start_date_time: null,
          end_date_time: null,
        },
        sorting: {
          key: null,
          order: null,
        },
        filter: [
          {
            key: null,
            value: null,
          },
        ],
        filter_function: [
          {
            key: null,
            value: null,
          },
        ],
        filterOperator: null,
        is_use_bulking_update: false,
        column_bulking_update: null,
        search_options_list: [],
        summary_block: [],
      },
      idConfiguration: 'calendarConfiguration',
      isOpenConfiguration: false,
      showModalExternalUrl: false,
      formUi: null,
      formData: null,
      variableOptions: [],
      variableOptionsClass: [],
      variableOptionsText: [],
      variableOptionsDate: [],
      variableOptionsTag: [],
      listFunction: [],
      showPopover: false,
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
    };
  },

  computed: {
    ...mapState('jStoreFormUi', ['form_data_detail']),
    ...mapState('jStoreExperienceManagerV2', ['showModalFieldLibrary', 'isShowModalFieldFromGroup', 'showModalExternalApi']),

    genData() {
      const { title, column, filter, filter_function, filterOperator, search_options_list, sorting } = this.dataSetup;

      const params = this._.cloneDeep(this.formDetail);
      params.calendar_view = {
        title,
        column: {
          title: column.title || '',
          description: column.description || '',
          color: column.color || '',
          start_date_time: column.start_date_time || '',
          end_date_time: column.end_date_time || '',
        },
        sort: {},
        filter: {},
        filter_function: {},
        filter_operator: filterOperator || '',
        search_options_list: search_options_list.length > 0 ? search_options_list : null,
      };

      if (filter.length > 0) {
        const counter = {};
        filter.forEach((e) => {
          if (e.key) {
            counter[e.key.id] = (counter[e.key.id] || 0) + 1;
            if (counter[e.key.id] === 2) {
              params.calendar_view.filter[e.key.id] = [params.calendar_view.filter[e.key.id], e.value];
            } else if (counter[e.key.id] > 2) {
              const datas = params.calendar_view.filter[e.key.id];
              datas.push(e.value);
              params.calendar_view.filter[e.key.id] = datas;
            } else {
              params.calendar_view.filter[e.key.id] = e.value;
            }
          }
        });
      }

      if (filter_function.length > 0) {
        filter_function.forEach((e) => {
          if (e.key) {
            params.calendar_view.filter_function[e.key.id] = e.value;
          }
        });
      }

      if (sorting) {
        params.calendar_view.sort[sorting.key.id] = sorting.order.id === 'asc' ? 1 : -1;
      }

      return params;
    },

    optionVariables() {
      return {
        options: this.variableOptions,
        class: this.variableOptionsClass,
        text: this.variableOptionsText,
        date: this.variableOptionsDate,
        tag: this.variableOptionsTag,
      };
    },

    viewJsonData() {
      return JSON.stringify(this.formDetail.calendar_view, null, 4);
    },
  },

  watch: {
    form_data_detail(val) {
      const listColumns = Object.keys(val[0].columns);
      const listColumnsVal = Object.values(val[0].columns);

      this.variableOptions = [];
      this.variableOptionsClass = [];
      this.variableOptionsText = [];
      this.variableOptionsDate = [];
      this.variableOptionsTag = [];

      if (listColumns.length > 0) {
        listColumns.forEach((column, index) => {
          if (listColumnsVal[index].type !== '[]attachment') {
            this.variableOptions.push({
              id: column,
              label: column,
              text: column,
              type: listColumnsVal[index].type,
            });

            if (listColumnsVal[index].type === 'person') {
              this.variableOptionsClass.push({
                id: `${column}.company_user_id`,
                label: `${column}.company_user_id`,
                text: `${column}.company_user_id`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.name`,
                label: `${column}.name`,
                text: `${column}.name`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.email`,
                label: `${column}.email`,
                text: `${column}.email`,
                type: listColumnsVal[index].type,
              });
            } else if (listColumnsVal[index].type === 'object') {
              this.variableOptionsClass.push({
                id: `${column}.id`,
                label: `${column}.id`,
                text: `${column}.id`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.name`,
                label: `${column}.name`,
                text: `${column}.name`,
                type: listColumnsVal[index].type,
              });
            } else if (listColumnsVal[index].type === 'timer') {
              this.variableOptionsClass.push({
                id: `${column}.state`,
                label: `${column}.state`,
                text: `${column}.state`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.duration`,
                label: `${column}.duration`,
                text: `${column}.duration`,
                type: listColumnsVal[index].type,
              });
            } else if (listColumnsVal[index].type === 'tags') {
              this.variableOptionsClass.push({
                id: `${column}.name`,
                label: `${column}.name`,
                text: `${column}.name`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.background`,
                label: `${column}.background`,
                text: `${column}.background`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.font_color`,
                label: `${column}.font_color`,
                text: `${column}.font_color`,
                type: listColumnsVal[index].type,
              });
            } else {
              this.variableOptionsClass.push({
                id: column,
                label: column,
                text: column,
                type: listColumnsVal[index].type,
              });
            }

            if (listColumnsVal[index].type === 'tags') {
              this.variableOptionsTag.push({
                id: column,
                label: column,
                text: column,
                type: listColumnsVal[index].type,
              });
            } else if (listColumnsVal[index].type === 'timestamp') {
              this.variableOptionsDate.push({
                id: column,
                label: column,
                text: column,
                type: listColumnsVal[index].type,
              });
            } else if (listColumnsVal[index].type === 'text') {
              this.variableOptionsText.push({
                id: column,
                label: column,
                text: column,
                type: listColumnsVal[index].type,
              });
            }
          }
        });
      }

      if (this.formDetail.calendar_view) {
        const data = JSON.parse(JSON.stringify(this.formDetail.calendar_view));
        const { title, column, search_options_list, filter, filter_function, filter_operator, sort } = data;

        this.dataSetup.title = title;
        this.dataSetup.filterOperator = filter_operator || null;
        this.dataSetup.search_options_list = search_options_list || [];
        this.dataSetup.column = {
          title: column.title || null,
          description: column.description || null,
          color: column.color || null,
          start_date_time: column.start_date_time || null,
          end_date_time: column.end_date_time || null,
        };

        if (filter) {
          const keyFilter = Object.keys(filter);
          const valueFilter = Object.values(filter);
          if (keyFilter.length > 0) {
            this.dataSetup.filter = [];
            keyFilter.forEach((e, index) => {
              if (typeof valueFilter[index] === 'object') {
                valueFilter[index].forEach((v) => {
                  this.dataSetup.filter.push({
                    key: { id: e },
                    value: v,
                  });
                });
              } else {
                this.dataSetup.filter.push({
                  key: { id: e },
                  value: valueFilter[index],
                });
              }
            });
          }
        }

        if (filter_function) {
          const keyFilter = Object.keys(filter_function);
          const valueFilter = Object.values(filter_function);
          if (keyFilter.length > 0) {
            this.dataSetup.filter_function = [];
            keyFilter.forEach((e, index) => {
              this.dataSetup.filter_function.push({
                key: { id: e },
                value: valueFilter[index],
              });
            });
          }
        }

        if (sort && Object.keys(sort) && Object.values(sort)) {
          this.dataSetup.sorting = {
            key: { id: Object.keys(sort)[0] },
            order: Object.values(sort)[0] === 1 ? { id: 'asc' } : { id: 'desc' },
          };
        }
      }
    },

    showModalExternalApi(val) {
      if (val) {
        this.$refs.modalExternalApi.show();
        this.showModalExternalUrl = true;
      } else {
        this.$refs.modalExternalApi.hide();
        this.showModalExternalUrl = false;
      }
    },
  },

  async created() {
    this.getData();
    this.getDataCalendar();
    this.getListFunction();
  },

  methods: {
    ...mapActions('jStoreFormUi', [
      'actionGetDetailForm', 'actionGetDetailMultiForm', 'actionSetForm', 'actionSetMultiForm',
      'actionGetDetailFormData', 'actionGetSetupFormUi', 'actionGetSetupMultiFormUi', 'getFormData',
    ]),
    ...mapActions('jStoreAutomation', ['getDetailAutomation']),
    ...mapMutations('jStoreFormUi', ['setChangesValueView']),
    ...mapActions('jStoreNotificationScreen', ['toggleProblem']),

    async getData() {
      if (this.formDetail.form_data_id) {
        const dataFilter = {
          id: [this.formDetail.form_data_id],
        };
        const param = {
          limit: 0,
          page: 1,
          filter: JSON.stringify(dataFilter),
        };
        await this.actionGetDetailFormData(param);
      } else {
        await this.setExternalUrl();
      }
    },

    getListFunction() {
      const dataFilter = {
        company_id: this.session.user.company_id,
      };
      dataFilter['trigger.type'] = 'function';
      const param = {
        limit: 1000000,
        page: 1,
        sort: { created_at: -1 },
        filter: JSON.stringify(dataFilter),
      };
      this.getDetailAutomation(param).then((res) => {
        this.listFunction = res.data.data.map(e => ({
          id: e.trigger.function ? e.trigger.function.name : '',
          name: e.trigger.function ? e.trigger.function.name : '',
        }));
      });
    },

    getDataCalendar() {
      const req = {
        page: 1,
        limit: 1,
        filter: {
          id: [this.$route.params.id],
        },
      };

      if (this.isMultipleForm) {
        this.actionGetSetupMultiFormUi(req).then((res) => {
          const response = res.data[0];
          this.formUi = response;

          if (response.form_data_id) {
            const reqData = {
              form_data_id: response.form_data_id,
            };
            this.getFormData(reqData).then((param) => {
              this.formData = param.data;
              this.showComponent = true;
            });
          } else {
            this.formData = {
              columns: response.data_source.external_url.columns,
              primary_key: '',
            };
          }
          this.isLoading = false;
        });
      } else {
        this.actionGetSetupFormUi(req).then((res) => {
          const response = res.data[0];
          this.formUi = response;

          if (response.form_data_id) {
            const reqData = {
              form_data_id: response.form_data_id,
            };
            this.getFormData(reqData).then((param) => {
              this.formData = param.data;
              this.showComponent = true;
            });
          } else {
            this.formData = {
              columns: response.data_source.external_url.columns,
              primary_key: '',
            };
          }
          this.isLoading = false;
        });
      }
    },

    setExternalUrl() {
      const listColumns = Object.keys(this.formDetail.data_source.external_url.columns);
      const listColumnsVal = Object.values(this.formDetail.data_source.external_url.columns);

      this.variableOptions = [];
      this.variableOptionsText = [];
      this.variableOptionsDate = [];
      this.variableOptionsTag = [];

      if (listColumns.length > 0) {
        listColumns.forEach((column, index) => {
          this.variableOptions.push({
            id: column,
            label: column,
            text: column,
            type: listColumnsVal[index].type,
          });

          if (listColumnsVal[index].type === 'tags') {
            this.variableOptionsTag.push({
              id: column,
              label: column,
              text: column,
              type: listColumnsVal[index].type,
            });
          } else if (listColumnsVal[index].type === 'timestamp') {
            this.variableOptionsDate.push({
              id: column,
              label: column,
              text: column,
              type: listColumnsVal[index].type,
            });
          } else if (listColumnsVal[index].type === 'text') {
            this.variableOptionsText.push({
              id: column,
              label: column,
              text: column,
              type: listColumnsVal[index].type,
            });
          }
        });
      }

      if (this.formDetail.calendar_view) {
        const data = JSON.parse(JSON.stringify(this.formDetail.calendar_view));
        const { title, column, search_options_list, filter, filter_function, filter_operator, sort } = data;

        this.dataSetup.title = title;
        this.dataSetup.filterOperator = filter_operator || null;
        this.dataSetup.search_options_list = search_options_list || [];
        this.dataSetup.column = {
          title: column.title || null,
          description: column.description || null,
          color: column.color || null,
          start_date_time: column.start_date_time || null,
          end_date_time: column.end_date_time || null,
        };

        if (filter) {
          const keyFilter = Object.keys(filter);
          const valueFilter = Object.values(filter);
          if (keyFilter.length > 0) {
            this.dataSetup.filter = [];
            keyFilter.forEach((e, index) => {
              if (typeof valueFilter[index] === 'object') {
                valueFilter[index].forEach((v) => {
                  this.dataSetup.filter.push({
                    key: { id: e },
                    value: v,
                  });
                });
              } else {
                this.dataSetup.filter.push({
                  key: { id: e },
                  value: valueFilter[index],
                });
              }
            });
          }
        }

        if (filter_function) {
          const keyFilter = Object.keys(filter_function);
          const valueFilter = Object.values(filter_function);
          if (keyFilter.length > 0) {
            this.dataSetup.filter_function = [];
            keyFilter.forEach((e, index) => {
              this.dataSetup.filter_function.push({
                key: { id: e },
                value: valueFilter[index],
              });
            });
          }
        }

        if (sort && sort.length > 0) {
          const keySort = Object.keys(sort[0]);
          const valueSort = Object.values(sort[0]);

          this.dataSetup.sorting = {
            key: { id: keySort[0] },
            order: valueSort[0] === 1 ? { id: 'asc' } : { id: 'desc' },
          };
        }
      }
    },

    openConfiguration() {
      this.isOpenConfiguration = true;
      this.toggleConfiguration(true);
    },

    toggleConfiguration(status) {
      if (status) {
        setTimeout(() => {
          const element = document.getElementById(this.idConfiguration);
          if (element) element.classList.add('show-properties-field');
        }, 200);
      } else {
        const element = document.getElementById(this.idConfiguration);
        if (element) element.classList.remove('show-properties-field');

        setTimeout(() => {
          this.isOpenConfiguration = false;
        }, 200);
      }
    },

    closeModalFieldLibrary(data) {
      const element = document.getElementById('modalFieldLibrary');
      if (element) element.classList.remove('show');

      if (this.isShowModalFieldFromGroup) {
        if (data) this.setSourceModalFieldLibrary(data);
      }

      setTimeout(() => {
        this.setShowModalFieldLibrary(false);
        this.setIsShowModalFieldFromGroup(false);
      }, 300);
    },

    submitConfig(params) {
      this.dataSetup.title = params.title;
      this.dataSetup.column = params.column;
      this.dataSetup.filter = params.filter;
      this.dataSetup.filter_function = params.filter_function;
      this.dataSetup.filterOperator = params.filterOperator;
      this.dataSetup.sorting = params.sorting;
      this.dataSetup.search_options_list = params.search_options_list;

      this.setChangesValueView(true);
      this.toggleConfiguration(false);
    },

    resetData() {
      this.dataSetup = {
        title: null,
        server_side_pagination: false,
        column: {
          title: null,
          description: null,
          color: null,
          start_date_time: null,
          end_date_time: null,
        },
        sorting: {
          key: null,
          order: null,
        },
        filter: [
          {
            key: null,
            value: null,
          },
        ],
        filter_function: [
          {
            key: null,
            value: null,
          },
        ],
        filterOperator: null,
        is_use_bulking_update: false,
        column_bulking_update: null,
        search_options_list: [],
        summary_block: [],
      };
    },

    async submitForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        this.$swal({
          title: 'Update',
          text: `Are you sure to update ${this.formDetail.name}?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Update',
          confirmButtonColor: '#42a5ce',
          cancelButtonColor: '#D2232A',
          titleColor: '#D2232A',
        }).then(async (result) => {
          if (result.value) {
            let res;
            if (!this.isMultipleForm) {
              res = await this.actionSetForm(this.genData);
            } else {
              res = await this.actionSetMultiForm(this.genData);
            }
            if (!res.error) {
              this.setChangesValueView(false);
              const dataFilter = {
                id: [this.$route.params.id],
              };
              const param = {
                limit: 0,
                page: 1,
                filter: JSON.stringify(dataFilter),
              };
              if (!this.isMultipleForm) {
                await this.actionGetDetailForm(param);
              } else {
                await this.actionGetDetailMultiForm(param);
              }
            }
          }
        });
      } else {
        this.toggleProblem('Please completed the required Configuration');
      }
    },

    async deleteView() {
      this.$swal({
        title: 'Delete',
        text: 'Are you sure to delete this view?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          const params = this._.cloneDeep(this.formDetail);
          params.calendar_view = null;
          this.resetData();

          let res;
          if (!this.isMultipleForm) {
            res = await this.actionSetForm(params);
          } else {
            res = await this.actionSetMultiForm(params);
          }
          if (!res.error) {
            this.setChangesValueView(false);
            const dataFilter = {
              id: [this.$route.params.id],
            };
            const param = {
              limit: 0,
              page: 1,
              filter: JSON.stringify(dataFilter),
            };
            if (!this.isMultipleForm) {
              await this.actionGetDetailForm(param);
            } else {
              await this.actionGetDetailMultiForm(param);
            }
            this.toggleConfiguration(false);
          }
        }
      });
    },
  },

  validations() {
    return {
      dataSetup: {
        title: { required },
        column: {
          title: { required },
          description: { required },
          color: { required },
          start_date_time: { required },
          end_date_time: { required },
        },
        filter: {},
        filter_function: {},
        filterOperator: {},
        search_options_list: {},
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/menu/jCalendarView.vue